import $ from 'jquery';
import validate from 'jquery-validation';


export function initContactForm(contactForm) {
    $(document).ready(function () {
        $(contactForm).validate({
            rules: {
                name: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                name: "El campo es obligatorio.",
                email: {
                    required: "El campo es obligatorio.",
                    email: "El Email es inválido"
                }
            },
            submitHandler: function (form) {
                $(".error-message").hide();
                $.ajax({
                    url: form.action,
                    type: "post",
                    data: $(form).serialize(),
                    success: function (data) {
                        if (data.error) {
                            $("#result").html(data.errorMessage);
                            $(".error-message").show();
                        }
                        else {
                            $("#contact-form").hide();
                            $(".success-message").show();
                        }

                    },
                    error: function () {
                        $("#result").html('Error al enviar los datos');
                        $(".error-message").show();                        
                    }
                });
            }
        });

        // $(contactForm).submit(function (event) {
        //     event.preventDefault();
        // });
    });
}
